import list from "./list";
import create from "./create";
import send from "./send";

export default {
  namespaced: true,
  modules: {
    list,
    create,
    send,
  },
};
